import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  getAllPromptsList: [],
  getLlMVersionsList: [],
  getPromptById: {},
  getConditionPrompt: [],
  PromptScreenCondition: [],

  prompts: [],
  promptsLoading: false,
  prompt: {},
  promptLoading: false,

  llms: [],
  llmsLoading: false,
  promptScreens: [],
  promptScreensLoading: false,

  llmOverrides: [],
  llmOverridesLoading: false,

  // Tab-specific configurations for independent editing
  tabConfigurations: {
    org: {},
    practitioner: {},
    plan: {},
  },
  // Track which tabs have unsaved changes
  tabUnsavedChanges: {
    org: false,
    practitioner: false,
    plan: false,
  },
  // Tab-specific selections (practitioner ID, plan type)
  tabSelections: {
    practitioner: null,
    plan: null,
  },
};

const promptSlice = createSlice({
  name: 'promptSlice',
  initialState,
  reducers: {
    getAllPromptsListSlice: (state, { payload }) => {
      state.getAllPromptsList = payload;
    },
    getLLmVersionSlice: (state, { payload }) => {
      state.getLlMVersionsList = payload;
    },
    getPromptsByIdSlice: (state, { payload }) => {
      state.getPromptById = payload;
    },
    getPromptScreensSlice: (state, { payload }) => {
      state.promptScreens = payload;
    },
    getConditionPromptSlice: (state, { payload }) => {
      state.getConditionPrompt = payload;
    },
    getPromptScreenConditionSlice: (state, { payload }) => {
      state.PromptScreenCondition = payload;
    },
    // v2 state
    listPromptsSlice: (state, { payload }) => {
      state.prompts = payload;
    },
    getPromptSlice: (state, { payload }) => {
      state.prompt = payload;
    },
    listPromptsLoadingSlice: (state, { payload }) => {
      state.promptsLoading = payload;
    },
    getPromptLoadingSlice: (state, { payload }) => {
      state.promptLoading = payload;
    },
    listLlmsSlice: (state, { payload }) => {
      state.llms = payload;
    },
    listLlmsLoadingSlice: (state, { payload }) => {
      state.llmsLoading = payload;
    },
    listPromptScreensSlice: (state, { payload }) => {
      state.promptScreens = payload;
    },
    listPromptScreensLoadingSlice: (state, { payload }) => {
      state.promptScreensLoading = payload;
    },
    listLlmOverridesSlice: (state, { payload }) => {
      state.llmOverrides = payload;
    },
    listLlmOverridesLoadingSlice: (state, { payload }) => {
      state.llmOverridesLoading = payload;
    },
    // Tab configuration management
    setTabConfigurationSlice: (state, { payload }) => {
      const { tab, configurations } = payload;
      state.tabConfigurations[tab] = configurations;
    },
    updateTabConfigurationSlice: (state, { payload }) => {
      const { tab, useCaseKey, settingKey, optionKey, field, value } = payload;
      if (!state.tabConfigurations[tab]) {
        state.tabConfigurations[tab] = {};
      }
      if (!state.tabConfigurations[tab][useCaseKey]) {
        state.tabConfigurations[tab][useCaseKey] = {};
      }
      if (!state.tabConfigurations[tab][useCaseKey][settingKey]) {
        state.tabConfigurations[tab][useCaseKey][settingKey] = {};
      }
      if (!state.tabConfigurations[tab][useCaseKey][settingKey][optionKey]) {
        state.tabConfigurations[tab][useCaseKey][settingKey][optionKey] = {};
      }
      state.tabConfigurations[tab][useCaseKey][settingKey][optionKey][field] =
        value;
    },
    setTabUnsavedChangesSlice: (state, { payload }) => {
      const { tab, hasChanges } = payload;
      state.tabUnsavedChanges[tab] = hasChanges;
    },
    setTabSelectionSlice: (state, { payload }) => {
      const { tab, selection } = payload;
      state.tabSelections[tab] = selection;
    },
    resetTabConfigurationSlice: (state, { payload }) => {
      const { tab } = payload;
      state.tabConfigurations[tab] = {};
      state.tabUnsavedChanges[tab] = false;
      if (tab === 'practitioner' || tab === 'plan') {
        state.tabSelections[tab] = null;
      }
    },
    resetPromptsSlice: (state) => {
      state.prompts = [];
      state.promptsLoading = false;
    },
  },
});

const { actions, reducer } = promptSlice;

export const {
  getAllPromptsListSlice,
  getLLmVersionSlice,
  getPromptsByIdSlice,
  getPromptScreensSlice,
  getConditionPromptSlice,
  getPromptScreenConditionSlice,
  listPromptsSlice,
  listPromptsLoadingSlice,
  getPromptLoadingSlice,
  getPromptSlice,
  listLlmsSlice,
  listLlmsLoadingSlice,
  listPromptScreensSlice,
  listPromptScreensLoadingSlice,
  listLlmOverridesSlice,
  listLlmOverridesLoadingSlice,
  setTabConfigurationSlice,
  updateTabConfigurationSlice,
  setTabUnsavedChangesSlice,
  setTabSelectionSlice,
  resetTabConfigurationSlice,
  resetPromptsSlice,
} = actions;

export default reducer;
